// @ts-nocheck
/* eslint-disable */
export const keyboardDoubleArrowUpIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m282-225-42-42 240-240 240 240-42 42-198-198-198 198Zm0-253-42-42 240-240 240 240-42 42-198-198-198 198Z"/></svg>`,
    name: 'keyboard-double-arrow-up' as const
};